import { memo } from 'react';

import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

type TEditLastNameProps = {
  lastName: string;
  onChange: (value: string) => void;
};

const EditLastName = memo(({ lastName, onChange }: TEditLastNameProps) => {
  return (
    <label htmlFor="lastName" className="flex-1 flex-column gap-4 width-100-percent">
      <InputWithOverlay
        label="Last name *"
        dirtyError={({ dirty, setHasError }) => {
          const hasError = dirty && !lastName?.trim().length;
          setHasError(hasError);
        }}
        designSize="medium"
        inputProps={{
          id: 'lastName',
          value: lastName,
          onChange: (e) => onChange(e.target.value),
          placeholder: 'Add last name',
        }}
      />
    </label>
  );
});

EditLastName.displayName = 'EditLastName';

export default EditLastName;
